import Proptypes from 'prop-types';
import React from 'react'

import { BubbleMenu } from '@tiptap/react'
import { Separator } from 'twyne-new.ui';

import { customColors } from '@/modules/cms/views/post/components/builder/Content/TailwindSandbox/Twyne/config';

import { formatters } from '../utils';

import { useBubbleTiptap } from './Bubble';
import { bubbleFormatters } from './formatters';

export default function BubbleToolbar({ editor, size }) {
  const { popover } = useBubbleTiptap()

  const tippyOptions = {
    duration: 100,
    maxWidth: 'none',
    interactive: true,
    hideOnClick: true,
    onClickOutside: (instance, event) => {
      if (popover.current) {
        event.stopPropagation()
        return false
      }
    },
    onHide: () => {
      if (popover.current) return false
    },
  }

  const layoutClasses = `flex align-center ${size === 'small' ? 'flex-col' : 'flex-row'}`
  const styleClasses = [customColors.twyBgBaseAccent, customColors.twyBorderBase].join(' ')
  const handleMouseDown = event => {
    if (isFocusableElement(event.target)) return
    event.preventDefault()
  }

  return <>
    <BubbleMenu tippyOptions={tippyOptions} editor={editor}>
      <div onMouseDown={handleMouseDown} className={`${layoutClasses} ${styleClasses} border rounded-xs shadow-md p-1`}>
        <div className='flex'>
          {formatters.clearFormatter(editor)}
          {bubbleFormatters.titleFormatters(editor)}
          <CustomSeparator />
          {bubbleFormatters.markFormatters(editor)}
          <CustomSeparator />
        </div>
        <div className='flex'>
          {bubbleFormatters.alignFormatters(editor)}
          <CustomSeparator />
          {bubbleFormatters.colorFormatters(editor)}
          <CustomSeparator />
          {bubbleFormatters.listFormatters(editor)}
          <CustomSeparator />
        </div>
        <div className='flex'>
          {formatters.linkFormatters(editor)}
          <CustomSeparator />
          {bubbleFormatters.tableFormatters(editor)}
        </div>
      </div>
    </BubbleMenu>
  </>
}

const CustomSeparator = () => <Separator className="text-gray-700! mx-2 h-4" orientation='vertical' />

BubbleToolbar.propTypes = {
  editor: Proptypes.object,
}

const isFocusableElement = target => {
  if (!(target instanceof Element)) return false

  return !!target.closest([
    'input',
    'textarea',
    'select',
    'button',
    '[contenteditable="true"]',
    '[role="textbox"]',
    '[data-allow-focus="true"]',
  ].join(','))
}
